module.exports = __webpack_public_path__ + "static/img/1.4828c89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/1.png
// module id = ANtw
// module chunks = 0